import {ContentContainer, WithStyledProps} from '@coolcolduk/ui-mui';
import {Alert, Button, type StackProps, styled} from '@mui/material';

export interface ErrorComponentProps extends StackProps {
  message: string;
  buttonText?: string;
  handleClick?: () => void;
}

function ErrorComponentInternal({
  message,
  buttonText,
  handleClick,
  className,
  ...stackProps
}: WithStyledProps<ErrorComponentProps>) {
  return (
    <ContentContainer className={className} center minusAppBar data-testid="error-component" {...stackProps}>
      <Alert severity="error" sx={{mb: 2}}>
        {message}
      </Alert>
      {handleClick && buttonText && (
        <Button onClick={handleClick} variant="contained">
          {buttonText}
        </Button>
      )}
    </ContentContainer>
  );
}

export const ErrorComponent = styled(ErrorComponentInternal, {
  name: 'CcErrorComponent',
})<ErrorComponentProps>();

export default ErrorComponent;
